import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import {
  AvTabState,
  ClientLocalPubsubVirtualClassState,
  PubsubVirtualClassState,
  PubsubVirtualUserState,
} from "../../shared/types/av-state";
import { createReplaceAllReducer } from "../utils";

import { logInfoWithDebugFlag } from "utils/logger";

const initialState: ClientLocalPubsubVirtualClassState = {
  users: {},
  last_updated_at: null,
  av_tab_state: AvTabState.NotMain,
  observing_session_id: null,
  max_participant_bar_slots: 0,
};

export const PubsubVirtualClassStateSlice = createSlice({
  name: "pubsub_virtual_class_state",
  initialState,
  reducers: {
    updateVirtualUserState: (
      state,
      action: PayloadAction<{
        classUserId: string;
        virtualClassUserState: PubsubVirtualUserState;
        last_updated_at: number | null;
      }>,
    ) => {
      const { classUserId, virtualClassUserState } = action.payload;
      if (!state.users[classUserId]) {
        state.users[classUserId] = virtualClassUserState;
      } else {
        state.users[classUserId] = {
          ...state.users[classUserId],
          ...virtualClassUserState,
        };
      }
      state.last_updated_at = action.payload.last_updated_at;
    },
    clearVirtualClassState: (state) => {
      state.users = {};
      state.last_updated_at = null;
      state.observing_session_id = null;
      state.max_participant_bar_slots = 0;
    },
    updateLastUpdatedAt: (state, action: PayloadAction<number | null>) => {
      state.last_updated_at = action.payload;
    },
    updateVirtualClassState: (state, action: PayloadAction<PubsubVirtualClassState>) => {
      logInfoWithDebugFlag(
        "debug_virtual_class",
        "[PubsubVirtualClassStateSlice] updateVirtualClassState action received",
        action.payload,
      );
      const virtualClassUsers = action.payload.users;
      Object.keys(virtualClassUsers).forEach((classUserId) => {
        if (!state.users[classUserId]) {
          state.users[classUserId] = {};
        }
        state.users[classUserId] = {
          ...state.users[classUserId],
          ...virtualClassUsers[classUserId],
        };
      });
      state.last_updated_at = action.payload.last_updated_at;
    },
    updateAvTabState: (state, action: PayloadAction<AvTabState>) => {
      state.av_tab_state = action.payload;
    },
    setObservingSessionId: (state, action: PayloadAction<string | null>) => {
      state.observing_session_id = action.payload;
    },
    setMaxParticipantBarSlots: (state, action: PayloadAction<number>) => {
      state.max_participant_bar_slots = action.payload;
    },
  },
  extraReducers: createReplaceAllReducer("pubsub_virtual_class_state", () => initialState),
});

export const PubsubVirtualClassStateActions = PubsubVirtualClassStateSlice.actions;
